import { lazy, Suspense } from "react";
import { SkeletonPage } from "@/components/SkeletonLoaders.jsx";
import { Navigate } from "react-router-dom";

const Loadable = (Component) => (props) => (
    <Suspense fallback={<SkeletonPage />}>
        <Component {...props} />
    </Suspense>
);

// Lazy-loaded pages
const LaundryLandingPage = Loadable(lazy(() => import("./pages/LaundryLandingPage")));
const LaundryServiceListPage = Loadable(lazy(() => import("./pages/LaundryServiceListPage")));
const LaundrySlotBook = Loadable(lazy(() => import("./pages/LaundrySlotBook")));
const LaundrySummaryPage = Loadable(lazy(() => import("./pages/LaundrySummaryPage")));
const LaundryThanksPage = Loadable(lazy(() => import("./pages/LaundryThanksPage")));
const LaundrySubscriptionDetailsPage = Loadable(lazy(() => import("./pages/LaundrySubscriptionDetailsPage")));

const laundryRoutes = [
    {
        path: "laundry",
        children: [
            {
                index: true,
                element: <Navigate to="5" replace />,
            },
            {
                path: ":category_id",
                element: <LaundryLandingPage />,
            },
            {
                path: ":category_id/services",
                element: <LaundryServiceListPage />,
            },
            {
                path: ":category_id/slot-book",
                element: <LaundrySlotBook />,
            },
            {
                path: ":category_id/summary",
                element: <LaundrySummaryPage />,
            },
            {
                path: ":category_id/thanks",
                element: <LaundryThanksPage />,
            },
            {
                path: ":category_id/subscription/:subscription_id",
                element: <LaundrySubscriptionDetailsPage />,
            },
        ],
    },
];

export default laundryRoutes;
